import { useRankGroupsWithRanks } from '@/api/rank-groups';
import { ErrorCard } from '@starsoft/common/components';
import { useMemo } from 'react';
import RankGroup from './RankGroup';
import styles from './styles.module.scss';

export default function VipLevelModalContent() {
  const { error, isLoading, rankGroups, refetch } = useRankGroupsWithRanks();
  const RankGroups = useMemo(
    () =>
      rankGroups?.data?.map(rankGroup => (
        <RankGroup key={`rank-group-item-${rankGroup?.id}`} data={rankGroup} />
      )),
    [rankGroups],
  );
  const Skeletons = useMemo(
    () =>
      Array.from({ length: 9 })?.map((_, i) => (
        <RankGroup key={`rank-group-item-skeleton-${i}`} isLoading />
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} isDefaultColor />;
  }

  return (
    <div className={styles.container}>{isLoading ? Skeletons : RankGroups}</div>
  );
}
